import { $gettext } from '@/config/gettext'

const transports = [
  {
    code: 'flight',
    label: $gettext('Flight'),
    hasDeparture: true
  },
  {
    code: 'bus',
    label: $gettext('Bus'),
    hasDeparture: true
  },
  {
    code: 'own',
    label: $gettext('Own'),
    hasDeparture: false
  }
]

export {
  transports
}
